import Link from 'next/link'
import BreadCrumb from '../breadcrumb'
import styles from './index.module.scss'

const PolicyTemplate = (props) => {
  const policyItems = [
    {
      name: 'Aday Üyelik Aydınlatma Metni',
      route: '/aday-uyelik-aydinlatma-metni',
    },
    {
      name: 'Platform Üyelik Sözleşmesi',
      route: '/platform-uyelik-sozlesmesi',
    },
    {
      name: 'İşveren Aydınlatma Metni',
      route: '/isveren-uyelik-aydinlatma-metni',
    },
    { name: 'İlgili Kişi Başvuru Formu', route: '/ilgili-kisi-basvuru-formu' },
  ]

  const { children, dataTest, isDefaultPage, pageUrl, pageTitle } = props

  const mainUrl = process.env.NEXT_PUBLIC_MAIN_URL2

  const breadcrumb = [
    { text: 'Ana Sayfa', url: mainUrl },
    { text: 'Sözleşmeler', url: `${mainUrl}/sozlesmeler` },
  ]

  if (isDefaultPage) delete breadcrumb[1].url
  else {
    breadcrumb.push({ text: pageTitle })
  }

  const breadcrumbHead = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumb.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.text,
      item: item.url || '',
    })),
  }

  return (
    <>
      <div className={styles.main}>
        <BreadCrumb
          breadcrumb={breadcrumb}
          breadcrumbHead={breadcrumbHead}
          className="v5"
          addHead
        />
        <div className={`container ${styles.page} d-block d-lg-flex`}>
          <div
            className={`${styles.left} ${
              !isDefaultPage ? 'd-lg-block d-none' : ''
            }`}
          >
            <div className={styles.menu}>
              {policyItems.map((item, index) => (
                <Link key={index} href={`${mainUrl}/sozlesmeler${item.route}`}>
                  <a
                    className={`${styles.item} ${
                      item.route === pageUrl ? styles.active : ''
                    }`}
                  >
                    <span>{item.name}</span>
                    <i className="icon icon-angle-right"></i>
                  </a>
                </Link>
              ))}
            </div>
          </div>
          <div
            className={`${styles.right} ${
              isDefaultPage ? 'd-none d-lg-block' : ''
            }`}
          >
            <div data-test={dataTest} className={styles.policy}>
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default PolicyTemplate
